if ($(window).width() < 768) {
	$(window).on('scroll', function() {
		$('.header').addClass('header--fixed');
		
		if ($(window).scrollTop() == 0) {
			$('.header').removeClass('header--fixed');
		}
	});
}


if ($('.banner-main').length > 0) {
	$('.logo').css('color', 'white');
}


